export const TITLE = {
  title1: `Learn practically and theoretically how the EAO approaches current "hot topics" in implant dentistry`,
  title2: "In the programme:",
  title3: "4 workshops per day",
  title32: "Implant placement",
  title33: "How to deal with bony defects?",
  title34: "How to restore the implants?",
  title4: "View the full programme",
  carousel1: "7 of the best worldwide experts in implant dentistry",
  title5: "Golf resort Quinta da Marinha in Cascais, Portugal",
  title6: "Prices",
  title7: "Useful information",
};
